import { lazy } from 'react';

const Categories = lazy(() => import('./Categories'));

export default Categories;
